import { render, staticRenderFns } from "./DiscountBar.vue?vue&type=template&id=17f1482a&scoped=true"
import script from "./DiscountBar.vue?vue&type=script&lang=js"
export * from "./DiscountBar.vue?vue&type=script&lang=js"
import style0 from "./DiscountBar.vue?vue&type=style&index=0&id=17f1482a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f1482a",
  null
  
)

export default component.exports